import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { Button, QLogo, TextField } from '@netbasequid/core'
import { useDisplayTheme } from 'hooks/useUiState'
import { useFormContext } from 'react-hook-form'
import { AutomationId } from 'utils/automationUtil'
import useToast from 'hooks/useToast'
import { useLiveReportId } from 'hooks/useLiveReportConfigModalState'
import { getBaseUrl } from 'utils/urlUtil'
import { StyledLogo, StyledLoadingField, StyledActionsContainer } from './index.css'

const getLiveReportBaseUrl = () => {
  const v4Url = window.location.href
  const index = v4Url.indexOf('/cb/')

  if (index === -1) {
    throw new Error("'/cb/' not found in the current URL.")
  }
  const liveReportBaseUrl = `${getBaseUrl()}/cb/web/live-report/`

  return liveReportBaseUrl
}

const ReportLink = () => {
  const theme = useDisplayTheme()
  const { t } = useTranslation()
  const liveReportId = useLiveReportId()
  const { register } = useFormContext()
  const [reportLink, setReportLink] = useState('')
  const [addToast] = useToast()

  useEffect(() => {
    if (liveReportId.status === 'succeeded') {
      setReportLink(`${getLiveReportBaseUrl()}${liveReportId.data}`)
    }
  }, [liveReportId])

  return (
    <StyledActionsContainer data-testid={AutomationId.liveReportModal.reportLinkContainer}>
      {liveReportId.status === 'loading' ? (
        <StyledLoadingField mode={theme}>
          <StyledLogo>
            <QLogo fontSize={16} mode={theme} />
          </StyledLogo>
          {t('loadingThreeDot')}
        </StyledLoadingField>
      ) : (
        <TextField
          fullWidth
          mode={theme}
          readOnly
          value={reportLink}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...register('reportId', {
            value: liveReportId.data,
            required: true
          })}
        />
      )}
      <Button
        mode={theme}
        color="secondary"
        style={{ flex: 'none' }}
        onClick={() => {
          navigator.clipboard.writeText(reportLink)
          addToast({ message: t('reportLinkCopiedMsg') })
        }}>
        {t('copy')}
      </Button>
    </StyledActionsContainer>
  )
}

export default ReportLink
